<template>
  <template v-if="!pullRefresh">
    <van-list
      class="ob-list"
      :class="{
        'no-status': !loadStatus
      }"
      v-model:loading="listParams.loading"
      v-model:error="listParams.error"
      :finished="listParams.finished"
      :immediate-check="immediateCheck"
      :loading-text="loadStatus ? $t('common.loading') : ' '"
      :error-text="loadStatus ? $t('common.loadListError') : ' '"
      :finished-text="loadStatus ? $t('common.finished') : ' '"
      @load="onLoad"
    >
      <slot></slot>
    </van-list>
  </template>
  <van-pull-refresh
    v-else
    ref="pullRef" 
    v-model="refreshStatus"
    @refresh="onReset"
  >
    <template #loading>
      <div></div>
    </template>
    <van-list
      v-model:loading="listParams.loading"
      v-model:error="listParams.error"
      :finished="listParams.finished"
      :immediate-check="immediateCheck"
      :loading-text="$t('common.loading')"
      :error-text="$t('common.loadListError')"
      :finished-text="$t('common.finished')"
      @load="onLoad"
    >
      <slot></slot>
    </van-list>
  </van-pull-refresh>
</template>

<script>

export default {
  props: {
    load: {
      type: Function,
      default: () => {}
    },
    immediateCheck: {
      type: Boolean,
      default: false
    },
    pullRefresh: {
      type: Boolean,
      default: false
    },
    loadStatus: {
      type: Boolean,
      default: true
    }
  },

  setup (props, { expose, emit }) {

    const pullRef = ref(null)

    const refreshStatus = ref(false)

    const listParams = ref({
      error: false,
      loading: false,
      finished: false,
      pageData: {
        page: 1,
        limit: 20
      }
    })

    function onReset () {
      emit('refresh', true)
    }

    function onRefresh (val) {
      listParams.value = {
        error: false,
        loading: true,
        finished: false,
        pageData: {
          page: 1,
          limit: 20
        }
      }
      if (!props.immediateCheck || val) {
        onLoad()
      }
    }

    async function onLoad () {
      let { code, finished } = await props.load(listParams.value)
      setTimeout(() => {
        refreshStatus.value = false
        listParams.value.loading = false
        listParams.value.finished = finished
        if (code === 200) {
          listParams.value.pageData.page ++
        } else {
          listParams.value.finished = false
          listParams.value.error = true
        }
      }, 300)
    }

    expose({
      listParams,
      pullRef,
      onRefresh
    })

    return {
      pullRef,
      refreshStatus,
      listParams,
      onLoad,
      onReset,
      onRefresh
    }
  }

}

</script>

<style lang="postcss" scoped>
.van-list {
  min-height: 200px;
  :deep(.van-list__finished-text),:deep(.van-list__error-text),:deep(.van-list__loading) {
    padding: 16px;
    color: var(--color-text-disabled);
  }
}
.no-status {
  :deep(.van-list__finished-text),:deep(.van-list__error-text),:deep(.van-loading__text) {
    display: none;
  }
}

</style>